import { styled } from '@mui/material/styles';

import { FormattedCaption } from '#client/pages/EducationStudio/components/FormattedCaption/FormattedCaption';

export const StyledCaption = styled(FormattedCaption)(({ theme }) => ({
  marginBottom: '.5rem',
  '& span': {
    margin: 0
  },
  '& a': {
    color: theme.palette.focus40.main
  }
}));
